<template>
  <g-master name="coc"
            :endpoint="groupMaster.endpoint"
            :tableSetup="groupMaster.tableSetup"
            :modalFieldsSetup="groupMaster.modalFieldsSetup"
            :parentData="evParentData"
            @params="paramsTable"
            ref="master"
  >
    <template slot="customButton">
      <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
    </template>
    <template slot="masterModal" slot-scope="{record}">

      <g-lookup endpoint="coc"
                label="Concepto: "
                :formItemConfig="fiOptions"
                :selectedObj.sync="conceptoSeleccionado"
                :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
      >
      </g-lookup>

      <a-form-item v-bind="fiOptions" label="Descripción: ">
        <a-input
          v-decorator="['group_desc', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
      </a-form-item>

      <g-dropdown endpoint="hierarchy_lookup"
                  label="Tipo de pago:"
                  :formItemConfig="fiOptions"
                  :decorator="['type_pay', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  :params="id_h_param_type">
      </g-dropdown>

    </template>
  </g-master>
</template>

<script>
  export default {
    props: ['group_id'],

    data () {
      return {
        paramsT: {},
        conceptoSeleccionado: {},
        endpointExcel: 'group_/downloadExcel',
        fileNameExcel: 'ConceptosDeGrupos',
        id_h_param_type: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        groupMaster: {
          endpoint: 'groups',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Descripción', dataIndex: 'group_desc', sorter: true},
              {title: 'Tipo de pago', dataIndex: 'type_pay', sorter: true},
              {title: 'Naturaleza', dataIndex: 'coc_natu', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'company'},
            {name: 'type_pay'},
            {name: 'id_coc'},
            {name: 'group_desc'}
          ]
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    watch: {
      conceptoSeleccionado () {
        this.$refs.master.modal.form.setFieldsValue({
          group_desc: this.conceptoSeleccionado.description
        })
      }
    },
    computed: {
      evParentData () {
        return {
          group_id: this.group_id
        }
      },
      paramsExcel () {
        return {
          ...this.paramsT,
          columns: this.groupMaster.tableSetup.columns,
          ...this.evParentData
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Coc/Groups.vue